<kodit-dropdown
  formCtrlId="sifra-placanja-select"
  [options]="sifreOptions"
  [canFilter]="true"
  [formCtrl]="modelCtrl.controls.sifra"
  ctrlFilterBy="value,opis"
  ctrlPlaceholder="Unesite šifru plaćanja"
  (optionChanged)="handleOptionChange($event)"
>
  <ng-template #selectedItem let-obj>
    <div class="p-text-left">{{ obj.value }}</div>
  </ng-template>

  <ng-template #item let-obj>
    <div class="p-text-bold">{{ obj.value }}</div>
    <div class="p-text-left">{{ obj.opis }}</div>
  </ng-template>
</kodit-dropdown>


